export const getParamsFromObj = (params: Record<string, string | number | boolean>): string => {
  return Object.keys(params)
    .map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    })
    .join('&');
};
